import {BRAND_KEY} from '../../brand'

export const getGeneralSiteInfo = () => {
    const lang = window.gigya.thisScript.lang.originalLang
    const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
    const siteConsent = window.gigya.thisScript.globalConf.consentMapping[countryCode]
    return {
        lang,
        countryCode,
        siteConsent,
    }
}

export const accountInfo = (options) => {
    if (window.gigya) window.gigya.accounts.getAccountInfo(options)
}

export const setAccountInfo = (options) => {
    if (window.gigya) window.gigya.accounts.setAccountInfo(options)
}

export const getUserPreferences = (callback) => {
    accountInfo({include: 'preferences', callback})
}

export const setEntitlements = (event) => {
    const {sourceContainerID} = event

    const lang = window.gigya.thisScript.lang.originalLang
    const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
    const siteConsent = window.gigya.thisScript.globalConf.consentMapping[countryCode]

    const profiledCommunicationEl = document
        .getElementById(sourceContainerID)
        .querySelector('.gigya-completion-checkbox .gigya-input-checkbox')

    if (profiledCommunicationEl) {
        const profiledCommunicationChecked = profiledCommunicationEl.checked
        const userEntitlements = profiledCommunicationChecked ? [BRAND_KEY + countryCode] : []
        const consentGrantedObj = {
            isConsentGranted: profiledCommunicationChecked,
            entitlements: userEntitlements,
        }
        const preferencesObj = {}
        preferencesObj[siteConsent] = consentGrantedObj
        event.formModel.preferences = preferencesObj

        //console.debug(preferencesObj)

        return preferencesObj
    }
    return null
}

export const cleanBrandsPreferences = (sourceContainerID) => {
    const sourceContainerEl = document.getElementById(sourceContainerID)
    const profiledCommunicationEl = sourceContainerEl.querySelector('.gigya-input-checkbox')

    if (!profiledCommunicationEl.checked) {
        const brandsProfiles = sourceContainerEl.querySelectorAll(
            '.gigya-entitlement-checkbox .gigya-input-checkbox',
        )
        Array.from(brandsProfiles).forEach((brandProfile) => {
            brandProfile.checked = false
        })
    }
}

export const getMarketingPreferences = (gigyaCustomer) => {
    const lang = window?.gigya?.thisScript?.lang?.originalLang
    const countryCode = window?.gigya?.thisScript?.globalConf?.countryCodeMapping?.[lang]
    const siteConsent = window?.gigya?.thisScript?.globalConf?.consentMapping?.[countryCode]
    const isMarketingPreferences =
        gigyaCustomer?.preferences?.[siteConsent]?.isConsentGranted || false

    return isMarketingPreferences
}

export const setEntitlementsMarketing = (event) => {
    const {sourceContainerID} = event

    const lang = window.gigya.thisScript.lang.originalLang
    const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
    const siteConsent = window.gigya.thisScript.globalConf.consentMapping[countryCode]

    const profiledCommunicationEl = document
        .getElementById(sourceContainerID)
        .querySelector('.gigya-input-checkbox')

    const profiledCommunicationChecked = profiledCommunicationEl && profiledCommunicationEl.checked
    let userEntitlements = []

    // check if there is the siteConsent in the accountInfo
    if (Object.prototype.hasOwnProperty.call(event.accountInfo.preferences, 'siteConsent')) {
        userEntitlements = event.accountInfo.preferences[siteConsent].entitlements
    }
    // remove all the entitlements related to the current site
    userEntitlements = userEntitlements.filter((item) => !item.match(`${countryCode}$`))

    const BRAND = {
        BRAUN: 'braun',
        KENWOOD: 'kenwood',
        DELONGHI: 'delonghi',
        NUTRIBULLET: 'nutribullet',
    }

    if (profiledCommunicationChecked) {
        const wrapperEl = document.getElementById(sourceContainerID)
        const brands = Object.values(BRAND)
        brands.forEach((brand) => {
            const brandEntitlement = wrapperEl.querySelector(
                `.gigya-${brand}-checkbox .gigya-input-checkbox`,
            )?.checked

            if (brandEntitlement) userEntitlements.push(`${brand}${countryCode}`)
        })
    } else {
        userEntitlements = []
    }

    const isCG = {
        isConsentGranted: profiledCommunicationChecked,
        entitlements: userEntitlements,
    }
    const obj = {}
    obj[siteConsent] = isCG

    event.formModel.preferences = obj
}

export const setCustomData = (event, origin, hmc, campaignTags) => {
    event.formModel.data = {
        ...event.formModel.data,
        brands: {[`${BRAND_KEY}`]: true},
        origin: origin ?? 'ECOMMERCE',
        ...(hmc && {...hmc}),
        ...(campaignTags && {campaignTags}),
    }
}

export const bindGigyaToggleContent = (sourceContainerID) => {
    const wrapper = document.getElementById(sourceContainerID)
    const toggles = wrapper.querySelectorAll('.js-toggle-info')
    Array.from(toggles).forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault()
            //DLG.EVE.emit(EVENTS.GIGYA.TOGGLE.CONTENT, formID)
        })
    })
}

export const bindInfoSubscription = (sourceContainerID) => {
    const wrapper = document.getElementById(sourceContainerID)
    const subscriptionLabels = wrapper.querySelectorAll('.subscription-name-label')
    subscriptionLabels.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            if (e.target.classList.contains('js-toggle-info')) {
                e.preventDefault()
                //DLG.EVE.emit(EVENTS.GIGYA.TOGGLE.CONTENT, formID)
            }
        })
    })
}
